import { Heading, Text } from "@instacover/ui"
import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { ExtraIcons } from "@/components/icons/InstructionImageType"
import { ImageLayout } from "@/components/layouts/ImageLayout"

export const Route = createFileRoute("/$sessionId/_session/canceled")({
  component: CanceledPage,
})

function CanceledPage() {
  const { t } = useTranslation()

  return (
    <ImageLayout
      baseLayoutProps={{ hideCounter: true }}
      iconName={ExtraIcons.Expired}
      content={
        <>
          <Heading as="h2" variant="h1" className="text-left">
            {t("canceled.title")}
          </Heading>

          <div className="h-6 w-6 shrink-0" />

          <Text as="p" className="text-left">
            {t("canceled.text")}
          </Text>

          <div className="h-6 w-6 shrink-0" />
        </>
      }
    />
  )
}
